export enum SurveyType {
    IZVID,
    FTH_POROCILO,
}
